import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import ApplicationRepo from "../../repositories/ApplicationRepo";
import NmLogo from "./nm_logo.png";
import LinkItem from "./LinkItem";

import ReactGA from 'react-ga4';  
import ReactUA from 'react-ga';

export default function Home(props) {
	const { linkItems } = props;
	const [appCounts, setAppCounts] = useState(new Map());

	useEffect(() => {

		let ga_user_id = window.authProvider?.account['userName'];

		// Google Analytics - GA4 Version
		ReactGA.initialize(String(process.env.REACT_APP_GA4_TAG_ID), {gaOptions: { userId: ga_user_id } });
		ReactGA.set({ dimension1: ga_user_id });
		ReactGA.send("pageview");    

		// Google Analytics - UA Version
		ReactUA.initialize(String(process.env.REACT_APP_GA_TAG_ID), {gaOptions: {userId: ga_user_id} });
		ReactUA.set({ dimension1: ga_user_id });
		ReactUA.pageview(window.location.pathname + window.location.search);  
		
		window.addEventListener("resize", onWindowResized);
		onWindowResized();
		props.setStageName("ASSET");
		loadAppCount();

	}, []);

	const loadAppCount = async () => {
		let counts = await ApplicationRepo.getApplicationCount();
		console.log("counts", counts);
		let countMap = new Map();
		setMapValue(countMap, "ASSET", 0);
		counts.forEach((statusCount) => {
			if (statusCount.status === "Asset Review")
				setMapValue(countMap, "Asset Review", statusCount.totalCount);
		});

		setAppCounts(countMap);
	};

	const setMapValue = (mapList, mapKey, mapValue) => {
		console.log("Check value", mapKey, mapValue);
		if (mapList.get(mapKey)) mapList.set(mapKey, mapList.get(mapKey) + mapValue);
		else mapList.set(mapKey, mapValue);
	};

	const onWindowResized = () => {
		let height = 0;
		let body = window.document.body;
		let element = document.getElementById("asset-container");
		if (window.innerHeight) {
			height = window.innerHeight;
		} else if (body.parentElement.clientHeight) {
			height = body.parentElement.clientHeight;
		} else if (body && body.clientHeight) {
			height = body.clientHeight;
		}

		element.style.height = height - element.offsetTop + "px";
	};

	return (
		<Grid container Id="asset-container" spacing={0}>
			<Grid
				item
				xs={4}
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}>
				<img src={NmLogo} style={{ width: 325 }} alt="" />
			</Grid>
			<Grid item xs={8} style={{ backgroundColor: "#F3F6F9" }}>
				<Grid
					container
					justify="center"
					style={{
						paddingTop: 30,
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}>
					{linkItems.map((item, index) => (
						<Grid key={index} item>
							<LinkItem
								totalApp={appCounts.get(item.name)}
								bgColor={item.themeColor}
								linkText={item.name}
								linkRoute={item.route}
							/>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Grid>
	);
}
